import React, { Component } from 'react';
import {getDisplayName} from '../../lib/higherOrderComponentsUtility';

function getItemWithId(cardModel, id) {
	return cardModel.find((item) => item.uniqueId === id);
}

const withItemSelection = (Comp) => {
	class ItemSelection extends Component {
		constructor(props) {
			super(props);

			this.state = {
				isItemSelected: false,
			};

			this.selectItem = this.selectItem.bind(this);
			this.unselectItem = this.unselectItem.bind(this);
			this.selectNextItem = this.selectNextItem.bind(this);
			this.selectPreviousItem = this.selectPreviousItem.bind(this);
		}

		selectItem(id) {
			const item = getItemWithId(this.props.cardModel, id);
			const itemIndex = this.props.cardModel.indexOf(item);
			const nextIndex = (itemIndex + 1) % this.props.cardModel.length;
			const prevIndex = itemIndex === 0 ? this.props.cardModel.length - 1 : itemIndex - 1;

			this.setState({
				isItemSelected: true,
				id,
				prevId: this.props.cardModel[prevIndex].uniqueId,
				nextId: this.props.cardModel[nextIndex].uniqueId
			});
		}

		selectNextItem() {
			this.selectItem(this.state.nextId);
		}

		selectPreviousItem() {
			this.selectItem(this.state.prevId);
		}

		unselectItem(id) {
			this.setState({
				isItemSelected: false,
				id: undefined
			});
		}

		render() {
			let item;
			if (this.state.isItemSelected) {
				item = getItemWithId(this.props.cardModel, this.state.id);
			}

			return (<Comp {...this.props}
						onItemClick={this.selectItem}
						selectedItem={item}
						selectNext={this.selectNextItem}
						selectPrevious={this.selectPreviousItem}
						onClose={this.unselectItem}
					/>);
		}
	}

	ItemSelection.displayName = `WithItemSelection(${getDisplayName(Comp)})`;
	return ItemSelection;
}

export default withItemSelection;



// WEBPACK FOOTER //
// ./src/react/card/ItemSelection.jsx